import styled from 'styled-components'
import { get } from '@utils'

export const H5 = styled.h5`
  ${get('styles.h5')};
`
